var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadingtime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 5C16.425 5 12.5 8.925 12.5 13.75C12.5 18.575 16.425 22.5 21.25 22.5C26.075 22.5 30 18.575 30 13.75C30 8.925 26.075 5 21.25 5Z",
    fill: "url(#paint0_linear_1072_446)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 20C17.8038 20 15 17.1962 15 13.75C15 10.3038 17.8038 7.5 21.25 7.5C24.6962 7.5 27.5 10.3038 27.5 13.75C27.5 17.1962 24.6962 20 21.25 20Z",
    fill: "url(#paint1_linear_1072_446)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2498 15C20.9298 15 20.6098 14.8781 20.3661 14.6337L17.8661 12.1337C17.378 11.6456 17.378 10.8544 17.8661 10.3662C18.3536 9.87812 19.1461 9.87812 19.6336 10.3662L22.1336 12.8662C22.6217 13.3544 22.6217 14.1456 22.1336 14.6337C21.8898 14.8781 21.5698 15 21.2498 15Z",
    fill: "url(#paint2_linear_1072_446)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 30V32.5C8.75 33.875 9.875 35 11.25 35H32.5V27.5H11.25C9.875 27.5 8.75 28.625 8.75 30Z",
    fill: "url(#paint3_linear_1072_446)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 27.5H32.5H35C35.69 27.5 36.25 26.94 36.25 26.25V23.75C36.25 23.06 35.69 22.5 35 22.5H10C6.55375 22.5 3.75 25.3038 3.75 28.75V33.75C3.75 37.1962 6.55375 40 10 40H35C35.69 40 36.25 39.44 36.25 38.75V36.25C36.25 35.56 35.69 35 35 35H32.5H11.25C9.875 35 8.75 33.875 8.75 32.5V30C8.75 28.625 9.875 27.5 11.25 27.5Z",
    fill: "url(#paint4_linear_1072_446)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 32.5H12.5C11.81 32.5 11.25 31.94 11.25 31.25C11.25 30.56 11.81 30 12.5 30H28.75C29.44 30 30 30.56 30 31.25C30 31.94 29.44 32.5 28.75 32.5Z",
    fill: "url(#paint5_linear_1072_446)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 8.75C29.6798 8.75 29.3598 8.62813 29.1161 8.38375L26.6161 5.88375C26.128 5.39562 26.128 4.60437 26.6161 4.11625C27.1036 3.62812 27.8961 3.62812 28.3836 4.11625L30.8836 6.61625C31.3717 7.10438 31.3717 7.89562 30.8836 8.38375C30.6398 8.62813 30.3198 8.75 29.9998 8.75ZM13.3836 8.38375L15.8836 5.88375C16.3717 5.39562 16.3717 4.60437 15.8836 4.11625C15.3961 3.62812 14.6036 3.62812 14.1161 4.11625L11.6161 6.61625C11.128 7.10438 11.128 7.89562 11.6161 8.38375C11.8598 8.62813 12.1798 8.75 12.4998 8.75C12.8198 8.75 13.1398 8.62813 13.3836 8.38375ZM23.7498 1.25C23.7498 0.56 23.1898 0 22.4998 0H19.9998C19.3098 0 18.7498 0.56 18.7498 1.25C18.7498 1.94 19.3098 2.5 19.9998 2.5H22.4998C23.1898 2.5 23.7498 1.94 23.7498 1.25Z",
    fill: "url(#paint6_linear_1072_446)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9825 6.25L28.75 8.0175L28.2481 8.51937C27.7456 7.84875 27.1512 7.25438 26.4806 6.75188L26.9825 6.25ZM15.5175 6.25L13.75 8.0175L14.2519 8.51937C14.7544 7.84875 15.3488 7.25438 16.0194 6.75188L15.5175 6.25ZM20 5.1C20.4094 5.04062 20.8244 5 21.25 5C21.6756 5 22.0906 5.04062 22.5 5.1V2.5H20V5.1Z",
    fill: "url(#paint7_linear_1072_446)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1072_446",
    x1: 15.0662,
    y1: 19.935,
    x2: 27.435,
    y2: 7.56688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1072_446",
    x1: 16.8331,
    y1: 18.1675,
    x2: 25.6675,
    y2: 9.33313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1072_446",
    x1: 19.1161,
    y1: 13.3837,
    x2: 20.8836,
    y2: 11.6162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1072_446",
    x1: 13.9144,
    y1: 38.6963,
    x2: 28.805,
    y2: 23.8056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1072_446",
    x1: 10.0663,
    y1: 42.6513,
    x2: 32.8675,
    y2: 19.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1072_446",
    x1: 15.6787,
    y1: 36.1969,
    x2: 25.5719,
    y2: 26.3037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1072_446",
    x1: 15.9911,
    y1: 12.7594,
    x2: 26.5092,
    y2: 2.24125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1072_446",
    x1: 17.5,
    y1: 11.7675,
    x2: 25,
    y2: 4.2675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingtime);
export default __webpack_public_path__ + "static/media/readingtime.59ccd3c0eaa6eea47fc1577700fd927d.svg";
export { ForwardRef as ReactComponent };